var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidDirectionDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 42.7",
    style: {
      enableBackground: "new 0 0 30 42.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DE0E54",
    d: "M1.4,19.4c-1.7-1.4-1.9-4-0.5-5.6s4-1.9,5.6-0.5l4.4,3.8V4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4v13.1l4.4-3.8 c1.7-1.4,4.2-1.2,5.6,0.5c1.4,1.7,1.2,4.2-0.5,5.6l-11,9.4c-0.7,0.6-1.7,1-2.6,1s-1.8-0.3-2.6-1L1.4,19.4z M23.4,26.3L15,33.5 l-8.4-7.2c-1.7-1.4-4.2-1.2-5.6,0.5c-1.4,1.7-1.2,4.2,0.5,5.6l11,9.4c0.7,0.6,1.7,1,2.6,1c0.9,0,1.8-0.3,2.6-1l11-9.4 c1.7-1.4,1.9-4,0.5-5.6C27.6,25.1,25.1,24.9,23.4,26.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidDirectionDownIcon);
export default __webpack_public_path__ + "static/media/bid_direction_down_icon.09b0df45aa5d655be545fe4856554015.svg";
export { ForwardRef as ReactComponent };